import React from "react";

import * as yup from "yup";

import { Tag } from "clearsense-ui/components";
import ActionDropdown from "components/Common/ActionDropdown";
import { LinkText, Steward } from "components/Common/TableStyle";

const getStatusColor = text => {
  switch (text) {
    case "Approved":
      return "#EBF4EC";
    case "Draft":
      return "#FDF0E3";
    default:
      return "";
  }
};
export const BusinessGlossaryColumns = (
  handleEdit,
  handleDelete,
  userPermissions
) => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: 150,
    render: (text, row) => (
      <LinkText text={text} link={row.id} state={{ parent: text }} />
    ),
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: 350,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "# Domains",
    key: "domains_count",
    dataIndex: "domains_count",
    width: 350,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: 250,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: 250,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    width: 150,
    render: text => (
      <Tag
        color={getStatusColor(text ? "Approved" : "Draft")}
        label={text ? "Approved" : "Draft"}
      />
    ),
  },
  {
    title: "Days in Status",
    key: "days_in_status",
    dataIndex: "days_in_status",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    width: 100,
    render: (_, record) => (
      <ActionDropdown
        editProps={{
          onClick: () => handleEdit(record),
          "data-cy": "business-term-edit-button",
        }}
        deleteProps={{
          onClick: () => handleDelete(record),
          "data-cy": "business-term-delete-button",
        }}
        userPermissions={userPermissions}
        data-cy="business-term-action-button"
      />
    ),
  },
];

export const CREATE_BUSINESS_GLOSSARY_INITIAL_VALUES = {
  name: "",
  description: "",
  drafter: "",
  approver: "",
  variations: [],
};
export const CREATE_BUSINESS_GLOSSARY_VALIDATION_SCHEMA = yup.object({
  name: yup.string().trim().required("Name is required"),
  drafter: yup.object().required("Drafter is required"),
  approver: yup.object().required("Approver is required"),
  variations: yup.array().of(
    yup.object().shape({
      name: yup.string().trim().required("Variation name is required"),
      description: yup.string(),
    })
  ),
});
